import { Box, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import cssVars from '../../styles/vars.module.scss'
import RegisterForm from './registerForm';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import useTranslation from '../../hooks/useTranslation';
import CompanyKeyRegister from './companyKeyRegister';


const Register = ({ countries, stores }) => {

    const tabStyle = {
        width: "50%",
        color: cssVars.black,
        backgroundColor: cssVars.white,
        textTransform: "unset",
        fontSize: "16px",
        fontWeight: `${400} !important`
    }

    const active = {
        backgroundColor: `${cssVars.primary} !important`,
        color: `${cssVars.white} !important`
    }

    const profStyles = {
        borderLeft: `1px solid ${cssVars.gray} !important`
    }

    const { t } = useTranslation()
    const [value, setValue] = useState('1');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [companyRegisterFormType, setCompanyRegisterFormType] = useState(0)

    return (
        <Box sx={{ typography: 'body1', mt: 5, mb: 7, px: { xs: "15px", lg: 5 }, fontFamily: "inherit" }}>
            <Tabs
                onChange={handleChange}
                aria-label="lab API tabs example"
                indicatorColor={cssVars.white}
                sx=
                {{
                    mb: 4,
                    border: `1px solid ${cssVars.gray}`,
                    borderRadius: cssVars.radius
                }}
            >
                <Tab sx={value === "1" ? { ...tabStyle, ...active } : { ...tabStyle }} label={t("Individual")} value="1" />
                <Tab sx={value === "2" ? { ...tabStyle, ...active, ...profStyles } : { ...tabStyle, ...profStyles }} label={t("Company")} value="2" />
            </Tabs>
            <RegisterForm countries={countries} stores={stores} selectedForm={value} />
            {/* {
                value === "2" && companyRegisterFormType === 0 ?
                    <CompanyKeyRegister setCompanyRegisterFormType={setCompanyRegisterFormType} />
                    :
            } */}
        </Box>
    );
}

export default Register;